import { widgetRegistry } from "../registry";
import type { ChatWidgetPayload, JourneyPhase } from "../../../generated-api";

type Props = {
  widget: ChatWidgetPayload;
  onComplete: (result: unknown) => void;
  journeyPhase?: JourneyPhase | null;
};

export default function WidgetRenderer({
  widget,
  onComplete,
  journeyPhase,
}: Props) {
  const entry = widgetRegistry[widget.kind];
  if (!entry) return null;

  const Component = entry.component;
  return (
    <Component
      payload={widget.payload}
      onComplete={onComplete}
      journeyPhase={journeyPhase}
    />
  );
}
